import React from 'react';

import {observer} from "mobx-react";
import {MyScoresWidgetAsync} from "../../../../../widgets/my-scores-widget/components/my-scores-widget.async";
import {useLocation} from "react-router-dom";

export const SideBarModuleMyScores = observer(({controller}) => {
  const {state} = controller;
  const {isMyScores, showOdds, myScoresPage} = state;
  const location = useLocation();

  const myScoresProps = {
    location,
    showOdds,
    page: myScoresPage,
  }

  return isMyScores ? <MyScoresWidgetAsync {...myScoresProps}/> : null
});
